import { type ReactNode, useMemo } from 'react';

import { DataProvider } from '@visx/xychart';

import { type ThemeConfig, createSambaChartTheme } from './theme';

import type { Scale } from './axis/useXYScales';

export type ChartProviderProps = {
  children: ReactNode;
  theme?: Partial<ThemeConfig>;
  xScale: Scale;
  yScale: Scale;
  horizontal?: boolean | 'auto';
};

export const ChartProvider = ({ children, theme, xScale, yScale, horizontal }: ChartProviderProps) => {
  const chartTheme = useMemo(() => createSambaChartTheme(theme), [theme]);

  return (
    <DataProvider xScale={xScale} yScale={yScale} theme={chartTheme} horizontal={horizontal}>
      {children}
    </DataProvider>
  );
};
